export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "org_invoice_item": {
            "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad"])},
            "unit_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio unitario"])},
            "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
            "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descripción"])},
            "exporter_process_crop_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaque"])}
          }
        }
      },
      "en": {
        "model": {
          "org_invoice_item": {
            "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantity"])},
            "unit_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unit price"])},
            "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
            "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
            "exporter_process_crop_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Package"])}
          }
        }
      }
    }
  })
}